// Assets page filters (?state= ?site= ?category=), kept in the URL so a filtered list can be bookmarked or shared
// and the dashboard tiles can open one.

/** "No site" / "No category". */
export const NONE = 'none';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** A site or category filter from the URL: '' (all), 'none' or an id; anything else is ignored. */
export function idFilter(value: string | null): string {
  if (value === NONE) return NONE;
  return value && UUID.test(value) ? value : '';
}

/** The same filters with one changed ('' removes it); the others stay. */
export function withParam(params: URLSearchParams, key: string, value: string): URLSearchParams {
  const next = new URLSearchParams(params);
  if (value) next.set(key, value);
  else next.delete(key);
  return next;
}
